<div class="component-wrapper">
    <div>
        <header class="mt-1">
            <div class="grid grid-cols-2 justify-content-between gap-1">
                <div class="d-flex justify-content-start">
                    <span class="truncate badge-phase">{{phaseDescription}}</span>
                </div>
                <div class="d-flex justify-content-end">
                    <span class="truncate " [ngClass]="isEditable || isBerichtVisible ? 'status-open' : 'status-not-editable'" >{{getEnqCardText}}</span>
                </div>
            </div>
            <button class="title-button text-xl" (click)="onTitleClick()" role="link">
                {{ anfrage.nummer }}
                <br />
                <span class="line-clamp-1">{{ title }}</span>
            </button>
        </header>
        <section class="mt-2">
            <div class="col d-flex flex-column" style="flex-shrink: 0;">
                <kendo-label class="title" text="{{'enquiry-card.tender'|translate}}"></kendo-label>
                <span class="content">{{ausschreibung}}</span>
            </div>
        </section>
    </div>
    <footer class="d-flex justify-content-end">
        <!-- Öffnet die Anfrage in der normalen Detailansicht -->
        <button class="xfound-button-primary" *ngIf="isEditable" kendoButton (click)="onEditClick()" [title]="'application.edit' | translate" role="link" [attr.aria-label]="'application.edit' | translate">
            <i-lucide name="square-pen" aria-hidden="true"></i-lucide>
        </button>
        <button class="xfound-button-secondary" *ngIf="isViewVisible" kendoButton (click)="onViewClick()" [title]="'application.view' | translate" role="link" [attr.aria-label]="'application.view' | translate">
            <i-lucide name="eye" aria-hidden="true"></i-lucide>
        </button>
        <!-- Öffnet die Anfrage in der Berichtsphasenansicht-->
        <button [ngClass]="IsAnyBerichtInBearbeitung ? 'xfound-button-primary': 'xfound-button-secondary'" *ngIf="isBerichtVisible" kendoButton (click)="onBerichtClick()" [title]="'application.report' | translate" [attr.aria-label]="('application.report' | translate) + (IsAnyBerichtInBearbeitung ? (': ' + ('enquiry-card.newreport' | translate)) : '')">
            <i-lucide name="newspaper" aria-hidden="true"></i-lucide>
            <kendo-badge class="xfound-button-badge-red" size="medium" rounded="full" *ngIf="IsAnyBerichtInBearbeitung">
                <span class="badge-content" [title]="('enquiry-card.newreport' | translate)">{{'!'}}</span>
            </kendo-badge>
        </button>
        <button class="xfound-button-secondary" *ngIf="isAenderungsantraegeVisible" kendoButton (click)="onAenderungsantragClick()" [title]="'application.change-request' | translate" role="link" [attr.aria-label]="'application.change-request' | translate">
            <i-lucide name="pen-line" aria-hidden="true"></i-lucide>
        </button>
        <!-- Öffnet den Nachrichten Dialog -->
        <button class="message-button" [ngClass]="anfrage.anzahlUngelesenerNachrichten ? 'xfound-button-primary': 'xfound-button-secondary'" *ngIf="isMessageVisible" kendoButton (click)="onMessageClick()" [title]="'application.message' | translate" [attr.aria-label]="('application.message' | translate) + (anfrage.anzahlUngelesenerNachrichten ? (': ' + anfrage.anzahlUngelesenerNachrichten + ' ' + ('enquiry-card.newmessages' | translate)) : '')">
            <i-lucide name="message-square-text" aria-hidden="true"></i-lucide>
            <kendo-badge class="xfound-button-badge-red" size="medium" rounded="full" *ngIf="anfrage.anzahlUngelesenerNachrichten">
                <span class="badge-content" [title]="anfrage.anzahlUngelesenerNachrichten + ' ' + ('enquiry-card.newmessages' | translate)">{{ anfrage.anzahlUngelesenerNachrichten }}</span>
            </kendo-badge>
        </button>
        <!-- Öffnet den Antragsdatenblatt-Download Dialog -->
        <button class="xfound-button-secondary" *ngIf="isAntragsdatenblattAvailable" kendoButton (click)="onAntragsdatenblattClick()" [title]="'application.reportdownload' | translate" [attr.aria-label]="'application.reportdownload' | translate">
            <i-lucide name="download" aria-hidden="true"></i-lucide>
        </button>
        <!-- Öffnet Mittelabruf -->
        <button class="xfound-button-secondary" *ngIf="isMittelabrufVisible" (click)="onMittelAbrufenClick()" [title]="'enquiry-card.callForFunds' | translate" [attr.aria-label]="'enquiry-card.callForFunds' | translate">
            <i-lucide name="euro" aria-hidden="true"></i-lucide>
        </button>
        <!-- Öffnet den Freigeben Dialog -->
        <button *ngIf="freigabeAktiviert" class="xfound-button-secondary" kendoButton (click)="onShareClick()" [title]="'application.share' | translate" [attr.aria-label]="'application.share' | translate">
            <i-lucide name="share-2" aria-hidden="true"></i-lucide>
        </button>
        <!-- Öffnet den Anfrage-Zurückziehen Dialog -->
        <button class="xfound-button-secondary" *ngIf="isRevokable" kendoButton (click)="onRevokeClick()" [title]="'application.revoke' | translate" [attr.aria-label]="'application.revoke' | translate">
            <i-lucide name="iteration-cw" aria-hidden="true"></i-lucide>
        </button>
        <!-- Öffnet den Anfrage-Löschen Dialog -->
        <button class="xfound-button-secondary" *ngIf="isDeleteButtonVisible" kendoButton (click)="onDeleteClick()" [title]="'application.delete' | translate" [attr.aria-label]="'application.delete' | translate">
            <i-lucide name="trash" aria-hidden="true"></i-lucide>
        </button>
    </footer>
</div>